exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar-component__logo{border:none}.navbar-component__lang-dropdown a:hover{color:#555!important}.navbar-component__lang-flag-image{border-radius:3px}@media (min-width:1200px){.navbar-component .nav.navbar-nav>li>a{max-width:140px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/shared/navbar.scss
// module id = 1044
// module chunks = 0